import React from 'react';
import { TimesAlive } from './timesalive';
import './App.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSync, faArrowLeft, faArrowRight, faQuestion, faFolderOpen,
         faTimes, faVolumeMute, faVolumeDown, faPlay, faPause,
         faVideo, faMusic, faAdjust, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
 import { faCircle, faFileAlt } from '@fortawesome/free-regular-svg-icons'
 library.add(faSync, faArrowLeft, faArrowRight, faQuestion, faFolderOpen,
            faTimes, faVolumeMute, faVolumeDown, faPlay, faPause, faVideo,
            faMusic, faFileAlt, faCircle, faAdjust, faCheckCircle);

const anchorStyle = {
  color: 'white',
  textDecoration: 'none'
};
function App() {
  console.log("App render");
  return (
    <div className="App">
      <div className="logosContainer">
      </div>
      <div className="Times-Alive-container">
        <TimesAlive />
      </div>
      <div className="copyright">&copy; 2026 City Creek Press, Inc.</div>
    </div>
  );
}

export default App;
